import React, { useEffect,useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import { Form } from 'react-bootstrap';
import "./Login.css";
import loader from '../../assests/loader.gif';
import {validatelogin} from '../../Utils/validate';
import API from '../../Utils/Api';
import { setUserSession } from '../../Utils/Common';
import { gettoastwarning } from '../../Utils/Common';

const Login = () => {
  const navigate = useNavigate();
  const [loading,setLoading] = useState(false);
  const [error,setError] = useState();
  const [success,setSuccess] = useState();
  const [errors,setErrors] = useState({});
  const [inputs,setInputs] = useState({email:'',password:''});
  const [showNewPassword, setShowNewPassword] = useState(false);

useEffect(() => {
    document.title = `login | bluefaucet`;
    document.getElementById('bodywrap').className='login';
},[]); 
/* Start Value set */
const handleInputChange = (event) => {
    event.persist();
    setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
}
/* End Value set */
//Start Login check
const handleSubmit = (event) => {
  event.preventDefault();
  const validationErrors = validatelogin(inputs);
  const noErrors = Object.keys(validationErrors).length === 0;
  setError('');
  setSuccess('');
  setErrors({});
  setErrors(validationErrors);
  if(noErrors){
    setLoading(true);
    setLoading(true);
    let email=inputs.email;
    let password=inputs.password;
    
    let formData = new FormData(); 
    formData.append('email', email);
    formData.append('password', password);
    API.post('backoffice_login', formData)
      .then(response => {
      if(response.data.status === 0){
        //setError(response.data.message);
        setLoading(false); 
        gettoastwarning(response.data.message,'');
      }else{
         setError('');
         setLoading(false);
         setUserSession(response.data.data.token,response.data.data.department,response.data.data.level);
         navigate("/overview");
      }                  
    }).catch(error => {
       setLoading(false);
       gettoastwarning("Something went wrong. Please try again later.",'');
        //setError("Something went wrong. Please try again later.");
    });  
  }
}
//End Login check
  return (
    <>
      <div className="container d-flex align-items-center justify-content-center mains">
        <div className="row w-100 flex-column flex-md-row justify-content-center">
          <div className="col-md-12 d-flex flex-column flex-md-row p-0 vach">
            {/* Right Section - Brand Info (Shown First on Mobile) */}
            <div className="col-md-5 right-section d-flex flex-column justify-content-center align-items-center order-md-2">
              <div className="right-logo">
                <img
                  src="/assests/images/bluefaucet-logo.png"
                  alt="BlueFaucet Logo"
                  className="img-fluid"
                />
              </div>
              <p>
                Welcome to BlueFaucet
                <br />
                Where we take care of your business.
              </p>
              <div className="position-relative hello w-100">
                <div className="de-1">
                  <img
                    src="/assests/images/round.png"
                    alt="Decor 1"
                    className="img-fluid"
                  />
                </div>
                <div className="de-2">
                  <img
                    src="/assests/images/trikon.png"
                    alt="Decor 2"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            {/* Left Section - Sign In Form */}
            <div className="col-md-7 left-section d-flex flex-column justify-content-center">
              <h2>Sign in</h2>
              {error && (
              <div className="alert alert-danger">
                {error}
              </div>)
             }
              {success && (
                <div className="alert alert-success">
                  {success}
              </div>
              )}
              <form method="post" onSubmit={handleSubmit} enctype="multipart/form-data">
                <Form.Group className="mb-4">
                  <div className="input-group mb-1">
                    <span className="input-group-text">
                      <img
                        src="/assests/images/email.png"
                        alt="Email Icon"
                        className="img-fluid"
                      />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Email"
                      name="email"
                      onChange={handleInputChange} value={inputs.email} autoComplete="off" 
                    />
                  </div>
                  {errors.email && (<p className="text-danger text-start mb-0">{errors.email}</p>)}
                </Form.Group>
                 <Form.Group className="mb-4">
                <div className="input-group ggh mb-1">
                  <span className="input-group-text">
                    <img
                      src="/assests/images/password.png"
                      alt="Lock Icon"
                      className="img-fluid"
                    />
                  </span>
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Password"
                    name="password" id="password"
                    onChange={handleInputChange} value={inputs.password}
                  />
                  <div
                    className="input-group-text"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    <img
                      src={
                        showNewPassword
                          ? "/assests/images/frame-4.png"
                          : "/assests/images/frame-3.png"
                      }
                      alt="Toggle Password"
                      className="img-fluid"
                    />
                  </div>
                </div>
                {errors.password && (<p className="text-danger text-start mb-0">{errors.password}</p>)}
                </Form.Group>
                <p>
                  <Link to="forgot-password" className="text-decoration-none">
                    Forget your Password?
                  </Link>
                </p>
                <button type="submit" className="btn w-100">
                  SIGN IN
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {loading && (
       <div className="loadingClass">
        <img src={loader} alt="loader"/>
      </div>
       )}  
    </>
  );
};
export default Login;